import {Component, OnInit} from '@angular/core'
import {animate, style, transition, trigger} from '@angular/animations'
import {PreloaderService} from './preloader.service'

@Component({
    selector: 'app-preloader',
    templateUrl: './preloader.component.html',
    styleUrls: ['./preloader.component.css'],
    animations: [
        trigger('backdrop', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(250, style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate(1250, style({ opacity: 0 }))
            ])
        ]),
        trigger('spins', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(750, style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate(250, style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class PreloaderComponent implements OnInit {
  // @Input() preloaderState: boolean
  visible = true
  messege: string | null
  constructor(public service: PreloaderService) { }
  ngOnInit(): void {
    this.service.MSG.subscribe(msg => {
      // console.log('update message: ', msg)
      this.messege = msg
    })
  }

}
